import React, { useState, useEffect } from "react";
import Button from "../Button/Button";
import InputCell, { yearValidate } from "../InputCell/InputCell";
import Layout from "../Layout/Layout";
import PageHeader from "../PageHeader/PageHeader";
import PageTransition from "../PageTransition/PageTransition";
import portal from "../../stacks/portal/PortalAWS";
import searchCriteria from "../../data/searchCriteria";
import { Block } from "../../styles/commons";
import { Container, Row, Col, Form } from "reactstrap";
import { useErrorToast } from "../../hooks/useErrorToast";
import { useFormValidation } from "../../hooks/useFormValidation";

const portalAPI = portal.getInstance();

// Double purpose to both add and modify a user

const SearchCriteriaScreen = (props) => {
  // const {sofUserId} = props
  const clearForm = {
    description: "",
    companyIndustry: "",
    yearIncorporated: "",
    employees: 0,
    round: "",
    regType: "",
    securityTypes: [],
    industryNaics: [],
    legalForm: "",
    fundingAmountCurrency: "",
    revenueProducing: "",
    profit: "",
    city: "",
    stateOrCountry: "",
  };

  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState("");
  const [form, setForm] = useState(clearForm);
  const [isDirty, setIsDirty] = useState(false);
  // const [isAdmin, setIsAdmin] = useState(false)
  const { setErrorMsg, errorToast } = useErrorToast("");
  const { validated, setValidated, checkValidation } = useFormValidation(form, [
    "yearIncorporated",
  ]);

  const controlled = {
    form,
    setForm,
    setIsDirty,
    validated,
  };

  useEffect(() => {
    async function retrieve() {
      try {
        setLoading(true)
        setLoadingMsg('Loading DreamEx Connect criteria ...')
        const criteria = await portalAPI.retrieveCriteria()
        setForm({...clearForm, ...criteria})
        setLoading(false)
        setLoadingMsg('')
      }
      catch(err) {
        setLoading(false)
        setLoadingMsg('')
        setErrorMsg(`Retrieve error: ${JSON.stringify(err.message,null,2)}`);
        console.error(`Retrieve error: ${JSON.stringify(err.message,null,2)}`);
      }
    }
    retrieve();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function store() {
    try {
      let isValid = checkValidation();
      isValid = isValid && yearValidate(form["yearIncorporated"]);
      setValidated(isValid);

      // if (isValid) {
        setLoading(true)
        setLoadingMsg('Storing DreamEx Connect criteria ...')
        await portalAPI.storeCriteria(form)
        setLoading(false)
        setLoadingMsg('')
        setIsDirty(false)
      // }
    } catch (err) {
      setLoading(false);
      setLoadingMsg("");
      setErrorMsg(`Store error: ${JSON.stringify(err.message, null, 2)}`);
      console.error(`Store error: ${JSON.stringify(err.message, null, 2)}`);
    }
  }

  return (
    <Layout product='portal'>
      <PageHeader title='DreamEx Connect Criteria'>
      {isDirty && <div style={{textAlign: 'right'}}><Button click={store}>SAVE</Button></div>}
      </PageHeader>
      <PageTransition loading={loading} msg={loadingMsg}>
        <Container>
          <Row>
            <Col>
              <a style={{color: 'red', textDecoration: 'underline'}} href='https://youtu.be/MB9v33ToZNE' target='_blank' rel='noreferrer'>Please watch this short instructional video to ensure your profile is properly set up.</a>
            </Col>
          </Row>
          {/* <Row>
            <Col>
              <p>{`Please provide your company criteria to be used when investors search:`}</p>
            </Col>
          </Row> */}
          <Block>
            <Form>
              <Row>
                <Col>
                  <InputCell
                    controlled={controlled}
                    {...searchCriteria.description}
                    label='Describe your company in about 100 words or less:'
                    rows={5}
                  />
                </Col>
              </Row>
              <Row>
                <Col style={{ textAlign: 'left', marginBottom: '20px'}}>
                  <hr/>
                  <h4>
                  Optional but encouraged criteria to help funding sources find your company:
                  </h4>
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputCell
                    controlled={controlled}
                    {...searchCriteria.companyIndustry}
                    label='keywords'
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <InputCell controlled={controlled} {...searchCriteria.city} />
                </Col>
                <Col md={6}>
                  <InputCell
                    controlled={controlled}
                    {...searchCriteria.stateOrCountry}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  <InputCell
                    controlled={controlled}
                    {...searchCriteria.yearIncorporated}
                  />
                </Col>
                <Col md={2}>
                  <InputCell
                    controlled={controlled}
                    {...searchCriteria.employees}
                  />
                </Col>
                <Col md={2}>
                  <InputCell
                    controlled={controlled}
                    {...searchCriteria.fundingAmountCurrency}
                  />
                </Col>
              </Row>
              <Row form>
                <Col md={3}>
                  <InputCell
                    controlled={controlled}
                    {...searchCriteria.round}
                  />
                </Col>
                <Col md={3}>
                  <InputCell
                    controlled={controlled}
                    {...searchCriteria.regType}
                  />
                </Col>
                <Col md={3}>
                  <InputCell
                    controlled={controlled}
                    {...searchCriteria.securityTypes}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <InputCell
                    controlled={controlled}
                    {...searchCriteria.legalForm}
                  />
                </Col>
                <Col md={3}>
                  <InputCell
                    controlled={controlled}
                    {...searchCriteria.revenueProducing}
                  />
                </Col>
                <Col md={3}>
                  <InputCell
                    controlled={controlled}
                    {...searchCriteria.profitable}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <InputCell
                    controlled={controlled}
                    {...searchCriteria.industryNaics}
                  />
                </Col>
              </Row>
              {/* <Row>
            <Col>{JSON.stringify(form, null, 2)}</Col>
          </Row> */}
            </Form>
          </Block>
        </Container>
      </PageTransition>

      {errorToast}
    </Layout>
  );
};

export default SearchCriteriaScreen;
